import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["programSelect", "submitBtn"]
  static values = { programsUrl: String }

  connect() {
    this.element.querySelector("form")?.addEventListener("submit", () => this._disableSubmit())
  }

  _disableSubmit() {
    const btn = this.submitBtnTarget
    btn.disabled = true
    btn.innerHTML = `<svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>Saving...`
    btn.classList.add("opacity-75", "cursor-not-allowed")
  }

  portfolioChanged(event) {
    const portfolioId = event.target.value
    const select = this.programSelectTarget

    select.innerHTML = `<option value="">Select...</option>`
    if (!portfolioId) return

    fetch(`/company/portfolios/${portfolioId}/programs`, {
      headers: { "Accept": "application/json" }
    })
      .then(r => r.json())
      .then(programs => {
        programs.forEach(p => {
          const opt = document.createElement("option")
          opt.value = p.id
          opt.textContent = p.name
          select.appendChild(opt)
        })
      })
  }
}
